<template>
  <div v-if="showTime" class="box wait-box">
      <UserAvatar class="user" />
      <div class="wait-text">{{ $t('goldenFlower.finding', { val: name?.toLowerCase() }) }}</div>
  </div>
  <div class="box box2" v-else>
    <img :src="time" alt="" class="w-[40px] m-auto">
    <div class="title mt-[10px]">{{ $t('goldenFlower.timeout') }}</div>
    <div class="info">{{ $t('goldenFlower.noOpponent') }}</div>
    <div class="flex flex-col">
      <ButtonThe3DButton class="flex-1 mt-[20px] mb-[10px]" color="blue" @click="emits('rematch')">{{ $t('goldenFlower.Rematch') }}</ButtonThe3DButton>
      <ButtonThe3DButton class="flex-1 !ml-0" color="red" @click="emits('quite')">{{ $t('goldenFlower.Exit') }}</ButtonThe3DButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import time from '../img/time.png';

const props = defineProps<{ name: string, time: number, showTime: boolean }>();
const emits = defineEmits(['quite', 'rematch'])
</script>

<style scoped lang="scss">
.box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.wait-box {
  height: 210px;
  width: 233px;
  background-image: url('../img/wait-bg.avif');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  .user {
    position: absolute;
    width: 80px;
    height: 80px;
    left: 78.5px;
    width: 78px;
    height: 78px;
    top: 19.5px;
    border-radius: 50%;
    :deep(img) {
      width: 100%;
      height: 100%;
    }
  }
  .wait-text {
    position: absolute;
    bottom: 40px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
}
.box2 {
  width: 80%;
  padding: 20px;
  max-width: 360px;
  border-radius: 15px;
  border: 2px solid transparent;
  background-image:
    radial-gradient(50.85% 68.57% at 52.67% 74.29%, rgba(26, 33, 44, 0.7) 0%, rgba(6, 56, 0, 0.9) 100%),
    linear-gradient(180deg, #aa821c 0%, #fed697 70.01%, rgba(210, 149, 44, 0.9) 134.86%);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  box-shadow:
    inset 0 0 15.8px 0 #3e9f41,
    0 0 6px 0 #fdd935b2;
    .title {
      font-size: 24px;
      font-weight: 500;
      text-align: center;
      line-height: 12px;
    }
    .info {
      font-size: 16px;
      margin-top: 10px;
      text-align: center;
    }
}
</style>